export const keycloak: any = { value: null as any };
